import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import PortableText from "./portableText";

import * as styles from "../styles/components/fc-copy-block-page.module.css";

interface CopyBlockPageProps {
  _rawCopy?: any[];
}

const CopyBlockPage: React.FC<CopyBlockPageProps> = ({ _rawCopy }) => {
  if (!_rawCopy) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Container>
        <div className={cn("entry-content", styles.copy)}>
          <PortableText blocks={_rawCopy} />
        </div>
      </Container>
    </div>
  );
};

export default CopyBlockPage;
